import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "relative block z-1 bg-gradient-to-r from-clay-800 via-clay-600 to-clay-700" }
const _hoisted_2 = { class: "max-w-5xl mx-auto overflow-hidden transition-all transform bg-white divide-y divide-gray-100 shadow-2xl rounded-xl ring-1 ring-black ring-opacity-5" }
const _hoisted_3 = { class: "relative" }
const _hoisted_4 = {
  key: 0,
  class: "max-w-5xl py-2 mx-auto mt-2 text-sm font-thin text-gray-100"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "max-w-5xl mx-auto" }
const _hoisted_7 = {
  key: 0,
  class: "py-2 text-sm font-thin text-gray-100"
}
const _hoisted_8 = { class: "flex flex-wrap items-center -m-1" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "mx-auto max-w-7xl" }
const _hoisted_11 = { class: "" }
const _hoisted_12 = { class: "h-full min-h-screen md:flex bg-clay-50" }
const _hoisted_13 = { class: "p-6 mb-0 md:hidden" }
const _hoisted_14 = { class: "px-4 pt-4 pb-5 mx-auto border rounded-lg border-clay-300 bg-clay-100" }
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "hidden md:flex md:shrink-0" }
const _hoisted_17 = { class: "flex flex-col pt-6 pb-12 bg-white w-54" }
const _hoisted_18 = { class: "flex flex-col flex-1 min-h-0" }
const _hoisted_19 = { class: "flex flex-col flex-1 pt-5 pb-4 overflow-y-auto" }
const _hoisted_20 = {
  "aria-label": "Sidebar",
  class: "grid grid-cols-2 md:grid-cols-1"
}
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "truncate sm:pr-1" }
const _hoisted_23 = { class: "flex-col flex-1 min-w-0 overflow-visible bg-white md:flex sm:px-6 lg:px- lg:px-12 border-x-1 border-clay-300 md:border-y-0 border-y-1 md:rounded-none rounded-b-4xl" }
const _hoisted_24 = { class: "relative z-0 flex flex-1 px-4 py-8 mb-12 overflow-visible" }
const _hoisted_25 = { class: "relative z-0 flex-1 pt-6 focus:outline-hidden xl:order-last" }
const _hoisted_26 = { class: "relative inset-0 px-4 pb-6 sm:px-6 md:px-0" }
const _hoisted_27 = { class: "h-full" }
const _hoisted_28 = { class: "pt-5 pl-4 pr-4 contentful-tab" }
const _hoisted_29 = { class: "guidesTab md:h-full" }
const _hoisted_30 = { class: "mx-auto overflow-hidden transition-all transform bg-white divide-y divide-gray-200 max-w-7xl" }
const _hoisted_31 = { class: "px-4" }
const _hoisted_32 = { class: "block text-center" }
const _hoisted_33 = { class: "" }
const _hoisted_34 = { class: "mb-4 text-2xl leading-6 text-gray-700" }
const _hoisted_35 = { class: "font-semibold text-clay-600" }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { class: "space-x-3" }
const _hoisted_38 = { class: "overflow-hidden bg-white" }
const _hoisted_39 = { class: "px-4 py-5 bg-white sm:px-6" }
const _hoisted_40 = { class: "flex flex-wrap items-center justify-between -mt-2 -ml-4 sm:flex-nowrap" }
const _hoisted_41 = { class: "mt-2 ml-4" }
const _hoisted_42 = { class: "text-xl font-semibold leading-6 text-gray-900" }
const _hoisted_43 = { class: "mt-2 ml-4 shrink-0" }
const _hoisted_44 = ["href"]
const _hoisted_45 = {
  class: "grid gap-6 py-2 mb-8 text-sm text-gray-800 xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-2",
  id: "options"
}
const _hoisted_46 = {
  key: 0,
  class: "px-6 col-span-full"
}

import {computed, onMounted, ref} from "vue";
import {client} from '@/shared';
// @ts-ignore
import Paginate from "vuejs-paginate-next";
import {
    CategoryWithCount,
    SearchGuidesByCategory,
    SearchGuidesByCategoryResponse,
} from "@/dtos";
import ShowCard from "../Guides/Shows/ShowCardMinimal.vue";
import CharacterCard from "../Guides/Characters/CharacterCardMinimal.vue";
import {useDebounceFn} from "@vueuse/core";
import BlogPostCard from "../Blogs/BlogPostCardMinimal.vue";
import TalentProfileCard from "../Talent/TalentProfileCard.vue";
import SceneCard from "../Guides/Scenes/SceneCardMinimal.vue";
import TheatreCompanyCard from "../TheatreCompanies/TheatreCompanyCard.vue";
import OpportunityCard from "../Opportunities/OpportunityCardMinimal.vue";
import LearningModuleCardMinimal from "../LearningModules/LearningModuleCardMinimal.vue";
import QuizCard from "../Quizzes/QuizCard.vue";
import SkeletonCard from "@/main/components/skeletons/SkeletonCard.vue";
import _ from "lodash";
import CollegeProgramCard from "../CollegePrograms/CollegeProgramCard.vue";
import {trackEvent} from '@/shared';
import SongCardMinimal from "../Guides/Songs/SongCardMinimal.vue";
import MonologueCardMinimal from "../Guides/Monologues/MonologueCardMinimal.vue";
import WriterCardMinimal from "../Guides/Writers/WriterCardMinimal.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'GeneralSearch',
  setup(__props) {

// @ts-ignore
const resultsSection = ref(null);
let searchResponse = ref<SearchGuidesByCategoryResponse>({});
let results = ref<[]>([]);
let otherResults = ref<Array<CategoryWithCount>>([]);
let relatedTags = ref<string>([]);
let queryText = ref('');
let queryCategory = ref('');
let urlForAdvanceSearch = ref('/shows');
let request = ref<SearchGuidesByCategory>({});
let isRetrieving = ref(false);


onMounted(async () => {
    let urlParams = new URLSearchParams(window.location.search);
    let term = urlParams.get("term") ?? "shakespeare";
    queryText.value = decodeURIComponent(term);
    let category = urlParams.get("category") ?? "Shows"; 
    queryCategory.value = getValidCategoryOrDefault(decodeURIComponent(category));
    await searchGuidesByCategory(true);
});

const searchGuidesByCategory = async (isPageLoad: boolean = false) => {
    if (queryText.value.length >= 3) {

        if (!isPageLoad) {
            resultsSection.value.scrollIntoView({behavior: "smooth"});
        }

        if (isPageLoad) {
            resetPagination();
        }

        isRetrieving.value = true;

        request.value.q = queryText.value;
        request.value.category = queryCategory.value;
        document.title = `${queryText.value} | StageAgent`;

        await client.get<SearchGuidesByCategoryResponse>(new SearchGuidesByCategory(request.value))
            .then(res => {
                searchResponse.value = res;
                queryCategory.value = res.category;
                results.value = res.results;
                otherResults.value = res.categoriesWithCounts;
                relatedTags.value = res.relatedTags;
                suggestionsWhenNoResults.value = res.suggestions;
                urlForAdvanceSearch = otherResults.value
                    .find((r: CategoryWithCount) => r.category === queryCategory.value)
                    .url ?? "/shows";

                isRetrieving.value = false;
            });
        
        trackEvent( 'search', {
            search_term: queryText.value
        }, false);
    }
}

const onQueryTextChanged = useDebounceFn(async () => {
    await searchGuidesByCategory()
}, 1000)

const hasResults = computed(() => {
    return results.value?.length > 0;
})

const suggestionsWhenNoResults = ref<string>([]);
const hasSuggestions = computed(() => {
    return isRetrieving.value === false && queryText?.value.length >= 3 && suggestionsWhenNoResults.value.length > 0;
});

const onSuggestionClicked = async (suggestion: string) => {
    queryText.value = suggestion;
    resetPagination();
    await onQueryTextChanged();
}

const onOtherResultsClicked = async (clickedCategory: string) => {
    queryCategory.value = clickedCategory;
    resetPagination();
    await searchGuidesByCategory();
}

const onRelatedTagClicked = async (clickedTag: string) => {
    queryText.value = clickedTag;
    resetPagination();
    await onQueryTextChanged();
}

const paginationClickHandler = async (pageNum: any) => {
    request.value.currentPage = pageNum;
    await searchGuidesByCategory();
}

const resetPagination = () => {
    request.value.currentPage = 1;
}

const getPageCount = () => {
    return Math.ceil(searchResponse.value.totalResults / 12);
}

let getClassForCard = computed(() => {
    let fourCol = "";
    let threeCol = "";
    let twoCol = "";

    switch (queryCategory.value) {
        
        case 'Shows':
            return fourCol;
        case 'Companies':
        case 'College Programs':
            return threeCol;
        case 'Talent profiles':
        case 'Quizzes':
            return threeCol;
        default:
            return twoCol;
    }
})

const getValidCategoryOrDefault = (incomingCategory: string) => {
    let validCategories = {
        "Shows": ['Shows', 'shows'],
        "Characters": ['Characters', 'characters'],
        "Monologues": ['Monologues', 'monologues'],
        "Scenes": ['Scenes', 'scenes'],
        "Songs": ['Songs', 'songs'],
        "Playwrights & composers": ['Playwrights & composers', 'Writers', 'writers'],
        "Learning modules": [
            'Learning modules',
            'learning modules'],
        "Auditions & Jobs": ['Auditions & Jobs', 'auditions-jobs'],
        "Companies": ['Companies', 'companies', 'theatre companies', 'theatre'],
        "College Programs": ['College programs', 'College Programs', 'college', 'programs'],
        "Talent profiles": ['Talent profiles', 'talent profiles', 'Talent', 'talent'],
        "Blog articles": ['Blog articles', 'blog articles', 'blog', 'articles'],
        "Quizzes": ['Quizzes', 'quizzes'],
    };

    let category = _.findKey(validCategories, function (cat) {
        return cat.includes(incomingCategory)
    });

    return category ?? "Learning modules";
}


let nextHtml = `<span class="hidden md:inline-block">Next</span>
                        <svg class="w-5 h-5 ml-3 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path fill-rule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd" />
                        </svg>`;

let prevHtml = `<svg class="w-5 h-5 mr-3 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path fill-rule="evenodd" d="M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z" clip-rule="evenodd" />
                        </svg>
                        <span class="hidden md:inline-block">Previous</span>`;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        ref_key: "resultsSection",
        ref: resultsSection,
        class: "z-10 p-4 space-y-3 overflow-y-auto sm:p-6 md:p-20"
      }, [
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "mb-12 text-center" }, [
          _createElementVNode("h1", { class: "text-4xl font-extrabold tracking-tight text-clay-50 sm:text-5xl md:text-6xl" }, [
            _createTextVNode(" Search "),
            _createElementVNode("span", { class: "tracking-tight text-white font-display" }, "StageAgent")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[5] || (_cache[5] = _createElementVNode("svg", {
              class: "pointer-events-none absolute top-3.5 left-4 h-5 w-5 text-gray-400",
              viewBox: "0 0 20 20",
              fill: "currentColor",
              "aria-hidden": "true"
            }, [
              _createElementVNode("path", {
                "fill-rule": "evenodd",
                d: "M9 3.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM2 9a7 7 0 1112.452 4.391l3.328 3.329a.75.75 0 11-1.06 1.06l-3.329-3.328A7 7 0 012 9z",
                "clip-rule": "evenodd"
              })
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(queryText) ? (queryText).value = $event : queryText = $event)),
              onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(onQueryTextChanged) && _unref(onQueryTextChanged)(...args))),
              type: "text",
              class: "w-full h-12 pr-4 text-gray-800 placeholder-gray-400 bg-transparent border-0 pl-11 focus:ring-0 sm:text-sm",
              placeholder: "Search shows, learning modules, characters, themes, articles and more...",
              role: "combobox",
              "aria-expanded": "false",
              "aria-controls": "options"
            }, null, 544), [
              [_vModelText, _unref(queryText)]
            ])
          ])
        ]),
        (hasSuggestions.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[6] || (_cache[6] = _createElementVNode("span", { class: "mr-3 font-bold" }, "Did you mean:", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(suggestionsWhenNoResults.value, (suggestion) => {
                return (_openBlock(), _createElementBlock("span", {
                  class: "mr-2 underline cursor-pointer hover:no-underline",
                  onClick: _withModifiers(($event: any) => (onSuggestionClicked(suggestion)), ["prevent"])
                }, _toDisplayString(suggestion), 9, _hoisted_5))
              }), 256))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          (_unref(relatedTags).length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _cache[7] || (_cache[7] = _createElementVNode("p", { class: "inline-block mt-2 space-x-3 space-y-3 sm:ml-4 sm:mt-0" }, " Related searches:", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(relatedTags), (tag) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: tag,
                    class: "inline-block mt-2 space-x-3 space-y-3 sm:ml-4 sm:mt-0"
                  }, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("a", {
                        onClick: _withModifiers(($event: any) => (onRelatedTagClicked(tag)), ["prevent"]),
                        href: "#",
                        class: "inline-flex px-2 py-1 m-1 mb-2 text-xs font-medium border rounded-full text-clay-800 bg-clay-50 hover:border-clay-900 hover:border hover:text-clay-700 hover:bg-clay-100"
                      }, [
                        _createElementVNode("span", null, _toDisplayString(tag), 1)
                      ], 8, _hoisted_9)
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ], 512)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _cache[9] || (_cache[9] = _createElementVNode("h3", { class: "pb-2 text-sm font-semibold tracking-wide uppercase text-clay-800" }, " Results by Category ", -1)),
              _cache[10] || (_cache[10] = _createElementVNode("label", {
                for: "mobile-category-select",
                class: "sr-only"
              }, "Select a category", -1)),
              _withDirectives(_createElementVNode("select", {
                id: "mobile-category-select",
                name: "mobile-category-select",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(queryCategory) ? (queryCategory).value = $event : queryCategory = $event)),
                onChange: _cache[3] || (_cache[3] = ($event: any) => (onOtherResultsClicked(_unref(queryCategory)))),
                class: "block w-full px-4 py-2 mt-1 text-sm border rounded-md border-clay-300 focus:border-clay-500 focus:ring-clay-500 bg-clay-50 text-clay-900"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(otherResults), (result) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: result.category,
                    value: result.category
                  }, _toDisplayString(result.category) + " (" + _toDisplayString(_unref(isRetrieving) ? '...' : result.totalResults) + ") ", 9, _hoisted_15))
                }), 128))
              ], 544), [
                [_vModelSelect, _unref(queryCategory)]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _cache[13] || (_cache[13] = _createElementVNode("div", { class: "flex items-center px-4 shrink-0" }, null, -1)),
                  _createElementVNode("nav", _hoisted_20, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(otherResults), (result) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: result.category,
                        class: "space-y-5 text-clay-700"
                      }, [
                        _createElementVNode("a", {
                          onClick: _withModifiers(($event: any) => (onOtherResultsClicked(result.category)), ["prevent"]),
                          class: _normalizeClass([result.category === _unref(queryCategory) ? 'text-clay-900 bg-slate-100 font-bold': '', "flex items-center w-full px-4 py-2 text-xs font-medium capitalize rounded-md md:rounded-l-md sm:text-sm group hover:text-clay-900 hover:bg-slate-100"])
                        }, [
                          _createElementVNode("span", _hoisted_22, _toDisplayString(result.category), 1),
                          _cache[11] || (_cache[11] = _createTextVNode(" (")),
                          _createElementVNode("em", null, _toDisplayString(_unref(isRetrieving) ? '...' : result.totalResults), 1),
                          _cache[12] || (_cache[12] = _createTextVNode(") "))
                        ], 10, _hoisted_21)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, [
                              _createElementVNode("div", _hoisted_33, [
                                _createElementVNode("h3", _hoisted_34, [
                                  _cache[14] || (_cache[14] = _createTextVNode(" Search results for \"")),
                                  _createElementVNode("span", _hoisted_35, _toDisplayString(_unref(queryText)), 1),
                                  _cache[15] || (_cache[15] = _createTextVNode("\""))
                                ])
                              ])
                            ])
                          ]),
                          (_unref(isRetrieving))
                            ? (_openBlock(), _createBlock(SkeletonCard, {
                                key: 0,
                                class: "mt-3",
                                "card-style": "long",
                                "num-of-cards": 4
                              }))
                            : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                _createElementVNode("div", _hoisted_37, [
                                  _createElementVNode("div", _hoisted_38, [
                                    _createElementVNode("div", _hoisted_39, [
                                      _createElementVNode("div", _hoisted_40, [
                                        _createElementVNode("div", _hoisted_41, [
                                          _createElementVNode("h3", _hoisted_42, _toDisplayString(_unref(queryCategory)), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_43, [
                                          _createElementVNode("a", {
                                            href: _unref(urlForAdvanceSearch),
                                            class: "relative inline-flex items-center px-3 py-2 text-sm font-semibold text-white rounded-md shadow-sm bg-clay-600 hover:bg-clay-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-clay-600"
                                          }, "Advanced search", 8, _hoisted_44)
                                        ])
                                      ])
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_45, [
                                  (_unref(searchResponse).totalResults < 1)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                        _cache[16] || (_cache[16] = _createTextVNode(" Sorry, there are no results for the term \"")),
                                        _createElementVNode("em", null, _toDisplayString(_unref(queryText)), 1),
                                        _cache[17] || (_cache[17] = _createTextVNode("\" in the ")),
                                        _createElementVNode("em", null, _toDisplayString(_unref(queryCategory)), 1),
                                        _cache[18] || (_cache[18] = _createTextVNode(" category. Please adjust your search query or select a different category. "))
                                      ]))
                                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(results), (result) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: result.id,
                                          class: _normalizeClass([_unref(getClassForCard), "min-w-full mb-4"])
                                        }, [
                                          (_unref(queryCategory) === 'Shows')
                                            ? (_openBlock(), _createBlock(ShowCard, {
                                                key: 0,
                                                show: result
                                              }, null, 8, ["show"]))
                                            : (_unref(queryCategory) === 'Characters')
                                              ? (_openBlock(), _createBlock(CharacterCard, {
                                                  key: 1,
                                                  character: result
                                                }, null, 8, ["character"]))
                                              : (_unref(queryCategory) === 'Monologues')
                                                ? (_openBlock(), _createBlock(MonologueCardMinimal, {
                                                    key: 2,
                                                    monologue: result
                                                  }, null, 8, ["monologue"]))
                                                : (_unref(queryCategory) === 'Scenes')
                                                  ? (_openBlock(), _createBlock(SceneCard, {
                                                      key: 3,
                                                      scene: result
                                                    }, null, 8, ["scene"]))
                                                  : (_unref(queryCategory) === 'Songs')
                                                    ? (_openBlock(), _createBlock(SongCardMinimal, {
                                                        key: 4,
                                                        song: result
                                                      }, null, 8, ["song"]))
                                                    : (_unref(queryCategory) === 'Playwrights & composers')
                                                      ? (_openBlock(), _createBlock(WriterCardMinimal, {
                                                          key: 5,
                                                          writer: result
                                                        }, null, 8, ["writer"]))
                                                      : (_unref(queryCategory) === 'Learning modules')
                                                        ? (_openBlock(), _createBlock(LearningModuleCardMinimal, {
                                                            key: 6,
                                                            guide: result
                                                          }, null, 8, ["guide"]))
                                                        : (_unref(queryCategory) === 'Auditions & Jobs')
                                                          ? (_openBlock(), _createBlock(OpportunityCard, {
                                                              key: 7,
                                                              opportunity: result
                                                            }, null, 8, ["opportunity"]))
                                                          : (_unref(queryCategory) === 'Companies')
                                                            ? (_openBlock(), _createBlock(TheatreCompanyCard, {
                                                                key: 8,
                                                                company: result
                                                              }, null, 8, ["company"]))
                                                            : (_unref(queryCategory) === 'Talent profiles')
                                                              ? (_openBlock(), _createBlock(TalentProfileCard, {
                                                                  key: 9,
                                                                  talent: result
                                                                }, null, 8, ["talent"]))
                                                              : (_unref(queryCategory) === 'Blog articles')
                                                                ? (_openBlock(), _createBlock(BlogPostCard, {
                                                                    key: 10,
                                                                    post: result
                                                                  }, null, 8, ["post"]))
                                                                : (_unref(queryCategory) === 'Quizzes')
                                                                  ? (_openBlock(), _createBlock(QuizCard, {
                                                                      key: 11,
                                                                      quiz: result
                                                                    }, null, 8, ["quiz"]))
                                                                  : (_unref(queryCategory) === 'College Programs')
                                                                    ? (_openBlock(), _createBlock(CollegeProgramCard, {
                                                                        key: 12,
                                                                        program: result
                                                                      }, null, 8, ["program"]))
                                                                    : _createCommentVNode("", true)
                                        ], 2))
                                      }), 128))
                                ]),
                                (_unref(searchResponse).totalResults > 0)
                                  ? (_openBlock(), _createBlock(_unref(Paginate), {
                                      key: 0,
                                      modelValue: _unref(searchResponse).currentPage,
                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(searchResponse).currentPage) = $event)),
                                      "active-class": 'border-electric-500 text-electric-600 border-t-2 pt-4 px-4 inline-flex items-center text-sm font-medium',
                                      "click-handler": paginationClickHandler,
                                      "container-class": 'border-t border-gray-200 px-4 flex items-center justify-between sm:px-0',
                                      "margin-pages": 2,
                                      "next-class": '-mt-px w-0 flex-1 flex justify-end',
                                      "next-link-class": 'border-t-2 border-transparent pt-4 pl-1 inline-flex items-center text-sm font-medium text-clay-800 hover:text-gray-700 hover:border-clay-500',
                                      "next-text": _unref(nextHtml),
                                      "page-class": 'border-transparent text-clay-800 hover:text-gray-700 hover:border-clay-500 border-t-2 pt-4 px-4 sm:inline-flex items-center text-sm font-medium hidden',
                                      "page-count": getPageCount(),
                                      "page-range": 3,
                                      "prev-class": '-mt-px w-0 flex-1 flex',
                                      "prev-link-class": 'border-t-2 border-transparent pt-4 pr-1 inline-flex items-center text-sm font-medium text-clay-800 hover:text-gray-700 hover:border-clay-500',
                                      "prev-text": _unref(prevHtml)
                                    }, null, 8, ["modelValue", "next-text", "page-count", "prev-text"]))
                                  : _createCommentVNode("", true)
                              ]))
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})